import { defineMessages } from 'react-intl'

export default defineMessages({
  sessionExpired: {
    defaultMessage: 'Deine Session ist abgelaufen. Bitte melde dich erneut an.',
  },
  onlineAlertMessage: {
    defaultMessage: 'Sie sind wieder online!',
  },
  syncingAlertMessage: {
    defaultMessage: 'Sie sind wieder online - Daten werden synchronisiert...',
  },
  syncingErrorMessage: {
    defaultMessage:
      'Server aktuell nicht verfügbar - Daten werden nur lokal gespeichert',
  },
  offlineAlertMessage: {
    defaultMessage: 'Sie sind offline! - Daten werden nur lokal gespeichert',
  },
})
